var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50010)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 15.7734V20.5H3.51562V15.7734H4.6875Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51562 12.2578C3.51562 10.6398 4.82729 9.32812 6.44531 9.32812H13.5547C15.1727 9.32812 16.4844 10.6398 16.4844 12.2578H15.3125C15.3125 11.287 14.5255 10.5 13.5547 10.5H6.44531C5.4745 10.5 4.6875 11.287 4.6875 12.2578H3.51562Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4844 15.7734V20.5H15.3125V15.7734H16.4844Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.11719C0 6.82276 1.04933 5.77344 2.34375 5.77344C3.63817 5.77344 4.6875 6.82276 4.6875 8.11719H3.51562C3.51562 7.46997 2.99097 6.94531 2.34375 6.94531C1.69653 6.94531 1.17188 7.46997 1.17188 8.11719C1.17188 8.62628 1.49703 9.06091 1.95311 9.22214L2.34375 9.36023V13.4297C2.34375 14.4005 3.13075 15.1875 4.10156 15.1875H15.8984C16.8692 15.1875 17.6562 14.4005 17.6562 13.4297V9.36023L18.0469 9.22214C18.503 9.06091 18.8281 8.62628 18.8281 8.11719C18.8281 7.46997 18.3035 6.94531 17.6562 6.94531C17.009 6.94531 16.4844 7.46997 16.4844 8.11719H15.3125C15.3125 6.82276 16.3618 5.77344 17.6562 5.77344C18.9507 5.77344 20 6.82276 20 8.11719C20 8.98545 19.528 9.74196 18.8281 10.1468V13.4297C18.8281 15.0477 17.5165 16.3594 15.8984 16.3594H4.10156C2.48354 16.3594 1.17188 15.0477 1.17188 13.4297V10.1468C0.47195 9.74196 0 8.98545 0 8.11719Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51562 3.42969C3.51562 1.81167 4.82729 0.5 6.44531 0.5H13.5547C15.1727 0.5 16.4844 1.81167 16.4844 3.42969V14.0156H3.51562V3.42969ZM6.44531 1.67188C5.4745 1.67188 4.6875 2.45888 4.6875 3.42969V12.8438H15.3125V3.42969C15.3125 2.45888 14.5255 1.67188 13.5547 1.67188H6.44531Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.ff9568944336ac1ba8b24d3b4999da16.svg";
export { ForwardRef as ReactComponent };